import { useState } from 'react';
import { useAuth } from './context/AuthContext';

const COLORS = {
  navy:    '#0A2540',
  navyL:   '#163355',
  teal:    '#0EA5A4',
  amber:   '#D4A24C',
  cloud:   '#FAFAF7',
  gray:    '#64748B',
  grayL:   '#94A3B8',
  border:  'rgba(10,37,64,0.10)',
  red:     '#EF4444',
};

export default function LoginPage({ onClose }) {
  const { signIn, signUp, signInWithGoogle, resetPassword } = useAuth();
  const [tab, setTab]           = useState('login');
  const [rol, setRol]           = useState('');
  const [loading, setLoading]   = useState(false);
  const [success, setSuccess]   = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [error, setError]       = useState('');
  const [showPw, setShowPw]     = useState(false);
  const [showPw2, setShowPw2]   = useState(false);

  const [loginEmail,   setLoginEmail]   = useState(() => localStorage.getItem('kin_email') || '');
  const [loginPass,    setLoginPass]    = useState('');
  const [recordarme,   setRecordarme]   = useState(true);
  const [regNombre,  setRegNombre]  = useState('');
  const [regEmail,   setRegEmail]   = useState('');
  const [regPass,    setRegPass]    = useState('');
  const [terms,      setTerms]      = useState(false);

  const emailOk = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    if (!emailOk(loginEmail)) return setError('Ingresa un correo válido.');
    if (!loginPass)            return setError('Ingresa tu contraseña.');
    setLoading(true);
    const { error: err } = await signIn(loginEmail.trim(), loginPass);
    setLoading(false);
    if (err) return setError(err.message === 'Invalid login credentials' ? 'Correo o contraseña incorrectos.' : err.message);
    if (recordarme) localStorage.setItem('kin_email', loginEmail.trim());
    else localStorage.removeItem('kin_email');
    setSuccess('¡Bienvenido! Entrando...');
    setTimeout(onClose, 800);
  }

  async function handleRegister(e) {
    e.preventDefault();
    setError('');
    if (regNombre.trim().length < 2) return setError('Ingresa tu nombre completo.');
    if (!emailOk(regEmail))           return setError('Ingresa un correo válido.');
    if (regPass.length < 8)           return setError('La contraseña debe tener al menos 8 caracteres.');
    if (!rol)                         return setError('Selecciona cómo usas KIN.');
    if (!terms)                       return setError('Debes aceptar los Términos de uso.');
    setLoading(true);
    const { error: err } = await signUp(regEmail.trim(), regPass);
    setLoading(false);
    if (err) return setError(err.message);
    setConfirmEmail(regEmail.trim());
  }

  async function handleGoogle() {
    setError('');
    const { error: err } = await signInWithGoogle();
    if (err) setError(err.message);
  }

  async function handleForgot() {
    if (!emailOk(loginEmail)) return setError('Escribe tu correo primero.');
    setError('');
    const { error: err } = await resetPassword(loginEmail.trim());
    if (err) setError(err.message);
    else setSuccess('Te enviamos un enlace de recuperación.');
  }

  const inp = (extra = {}) => ({
    width: '100%', padding: '12px 14px',
    border: `1.5px solid ${COLORS.border}`, borderRadius: 10,
    fontFamily: 'Inter, system-ui, sans-serif', fontSize: 14,
    color: COLORS.navy, background: '#fff', outline: 'none',
    boxSizing: 'border-box',
    ...extra,
  });

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(6,26,46,0.65)', backdropFilter: 'blur(4px)',
    }} onClick={e => e.target === e.currentTarget && onClose()}>

      <div style={{
        background: '#fff', borderRadius: 20,
        width: '100%', maxWidth: 460, maxHeight: '95vh',
        overflowY: 'auto', boxShadow: '0 24px 80px rgba(6,26,46,0.28)',
        position: 'relative',
      }}>

        {/* Header */}
        <div style={{
          background: `linear-gradient(135deg, ${COLORS.navyL} 0%, ${COLORS.navy} 100%)`,
          padding: '28px 32px 24px', borderRadius: '20px 20px 0 0',
        }}>
          <button onClick={onClose} style={{
            position: 'absolute', top: 16, right: 16,
            background: 'rgba(255,255,255,.12)', border: 'none',
            color: '#fff', width: 32, height: 32, borderRadius: 8,
            cursor: 'pointer', fontSize: 18, display: 'flex',
            alignItems: 'center', justifyContent: 'center',
          }}>×</button>

          <div style={{ fontWeight: 900, fontSize: 22, color: '#fff', letterSpacing: -0.5 }}>
            K<span style={{ color: COLORS.teal }}>IN</span>
          </div>
          <p style={{ color: 'rgba(255,255,255,.55)', fontSize: 13, marginTop: 4 }}>
            Inteligencia de comercio exterior · Datos DIAN reales
          </p>
        </div>

        <div style={{ padding: '24px 32px 32px' }}>
          {confirmEmail ? (
            <div style={{ textAlign: 'center', padding: '8px 4px 4px' }}>
              <div style={{
                width: 64, height: 64, borderRadius: '50%',
                background: 'rgba(14,165,164,.1)', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontSize: 30, margin: '0 auto 20px',
              }}>✉️</div>
              <h2 style={{ fontSize: 19, fontWeight: 800, color: COLORS.navy, margin: '0 0 10px' }}>
                Revisa tu correo
              </h2>
              <p style={{ fontSize: 14, color: COLORS.gray, lineHeight: 1.6, margin: '0 0 4px' }}>
                Te enviamos un enlace de confirmación a
              </p>
              <p style={{ fontSize: 15, fontWeight: 700, color: COLORS.navy, margin: '0 0 18px', wordBreak: 'break-all' }}>
                {confirmEmail}
              </p>
              <div style={{
                background: COLORS.cloud, border: `1.5px solid ${COLORS.border}`,
                borderRadius: 10, padding: '14px 16px', marginBottom: 20,
                fontSize: 13, color: COLORS.gray, lineHeight: 1.6, textAlign: 'left',
              }}>
                <strong style={{ color: COLORS.navy }}>Haz clic en el enlace del correo</strong> para
                activar tu cuenta — sin eso no vas a poder iniciar sesión. Si no lo ves en unos minutos,
                revisa la carpeta de <strong style={{ color: COLORS.navy }}>Spam / No deseados</strong>.
              </div>
              <button type="button" onClick={() => {
                setConfirmEmail(''); setTab('login'); setError(''); setSuccess('');
                setRegNombre(''); setRegEmail(''); setRegPass(''); setTerms(false); setRol('');
              }} style={{
                width: '100%', padding: 14, background: COLORS.navy, color: '#fff',
                border: 'none', borderRadius: 10, fontFamily: 'inherit',
                fontSize: 15, fontWeight: 800, cursor: 'pointer', marginBottom: 12,
              }}>Ya confirmé, ir a iniciar sesión →</button>
              <p style={{ fontSize: 12, color: COLORS.grayL }}>
                ¿No te llegó nada? Escríbenos a{' '}
                <a href="mailto:hola@kin-map.com" style={{ color: COLORS.teal, fontWeight: 600 }}>hola@kin-map.com</a>
              </p>
            </div>
          ) : (
          <>
          {/* Tabs */}
          <div style={{
            display: 'flex', background: COLORS.cloud,
            border: `1.5px solid ${COLORS.border}`,
            borderRadius: 10, padding: 4, marginBottom: 24,
          }}>
            {['login', 'reg'].map(t => (
              <button key={t} onClick={() => { setTab(t); setError(''); setSuccess(''); }}
                style={{
                  flex: 1, padding: '9px 0', border: 'none', borderRadius: 7,
                  fontFamily: 'Inter, system-ui, sans-serif', fontSize: 14, fontWeight: 600,
                  cursor: 'pointer', transition: '.15s',
                  background: tab === t ? COLORS.navy : 'transparent',
                  color: tab === t ? '#fff' : COLORS.gray,
                  boxShadow: tab === t ? '0 2px 8px rgba(10,37,64,.2)' : 'none',
                }}>
                {t === 'login' ? 'Iniciar sesión' : 'Crear cuenta'}
              </button>
            ))}
          </div>

          {/* Mensajes */}
          {success && (
            <div style={{
              background: 'rgba(14,165,164,.08)', border: `1.5px solid rgba(14,165,164,.3)`,
              borderRadius: 10, padding: '12px 16px', marginBottom: 16,
              fontSize: 13, color: COLORS.teal, textAlign: 'center',
            }}>{success}</div>
          )}
          {error && (
            <div style={{
              background: '#fff5f5', border: `1.5px solid rgba(239,68,68,.3)`,
              borderRadius: 10, padding: '12px 16px', marginBottom: 16,
              fontSize: 13, color: COLORS.red,
            }}>{error}</div>
          )}

          {/* Google */}
          <button onClick={handleGoogle} style={{
            width: '100%', padding: '12px 20px',
            background: '#fff', border: `1.5px solid ${COLORS.border}`,
            borderRadius: 10, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            fontFamily: 'Inter, system-ui, sans-serif', fontSize: 14, fontWeight: 600,
            color: COLORS.navy, marginBottom: 18, boxSizing: 'border-box',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
            <div style={{ flex: 1, height: 1, background: COLORS.border }} />
            <span style={{ fontSize: 12, color: COLORS.grayL, fontWeight: 500 }}>
              {tab === 'login' ? 'o inicia con tu email' : 'o regístrate con tu email'}
            </span>
            <div style={{ flex: 1, height: 1, background: COLORS.border }} />
          </div>

          {/* ── LOGIN ── */}
          {tab === 'login' && (
            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: COLORS.navy, marginBottom: 6 }}>
                  Correo electrónico
                </label>
                <input style={inp()} type="email" placeholder="tu@empresa.com"
                  value={loginEmail} onChange={e => setLoginEmail(e.target.value)} autoComplete="email" />
              </div>
              <div style={{ marginBottom: 6 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: COLORS.navy, marginBottom: 6 }}>
                  Contraseña
                </label>
                <div style={{ position: 'relative' }}>
                  <input style={inp({ paddingRight: 60 })} type={showPw ? 'text' : 'password'}
                    placeholder="Tu contraseña" value={loginPass}
                    onChange={e => setLoginPass(e.target.value)} autoComplete="current-password" />
                  <button type="button" onClick={() => setShowPw(!showPw)} style={{
                    position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer',
                    fontSize: 12, fontWeight: 600, color: COLORS.grayL, fontFamily: 'inherit',
                  }}>{showPw ? 'Ocultar' : 'Ver'}</button>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input type="checkbox" id="recordarme" checked={recordarme} onChange={e => setRecordarme(e.target.checked)}
                    style={{ width: 15, height: 15, accentColor: COLORS.teal, cursor: 'pointer', flexShrink: 0 }} />
                  <label htmlFor="recordarme" style={{ fontSize: 13, color: COLORS.gray, cursor: 'pointer' }}>
                    Recordarme
                  </label>
                </div>
                <button type="button" onClick={handleForgot} style={{
                  background: 'none', border: 'none', cursor: 'pointer',
                  fontSize: 12, color: COLORS.gray, fontWeight: 600,
                  fontFamily: 'inherit',
                }}>¿Olvidaste tu contraseña?</button>
              </div>
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: 14, background: loading ? COLORS.grayL : COLORS.navy,
                color: '#fff', border: 'none', borderRadius: 10,
                fontFamily: 'inherit', fontSize: 15, fontWeight: 800,
                cursor: loading ? 'not-allowed' : 'pointer', marginBottom: 16,
              }}>{loading ? 'Ingresando...' : 'Ingresar →'}</button>
              <p style={{ textAlign: 'center', fontSize: 13, color: COLORS.gray }}>
                ¿No tienes cuenta?{' '}
                <button type="button" onClick={() => { setTab('reg'); setError(''); setSuccess(''); }}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: COLORS.teal, fontWeight: 700, fontFamily: 'inherit', fontSize: 13 }}>
                  Crear cuenta gratis
                </button>
              </p>
            </form>
          )}

          {/* ── REGISTRO ── */}
          {tab === 'reg' && (
            <form onSubmit={handleRegister}>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: COLORS.navy, marginBottom: 6 }}>
                  Nombre completo
                </label>
                <input style={inp()} type="text" placeholder="Ej: Carlos Ramírez"
                  value={regNombre} onChange={e => setRegNombre(e.target.value)} autoComplete="name" />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: COLORS.navy, marginBottom: 6 }}>
                  Correo electrónico
                </label>
                <input style={inp()} type="email" placeholder="tu@empresa.com"
                  value={regEmail} onChange={e => setRegEmail(e.target.value)} autoComplete="email" />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: COLORS.navy, marginBottom: 6 }}>
                  Contraseña
                </label>
                <div style={{ position: 'relative' }}>
                  <input style={inp({ paddingRight: 60 })} type={showPw2 ? 'text' : 'password'}
                    placeholder="Mínimo 8 caracteres" value={regPass}
                    onChange={e => setRegPass(e.target.value)} autoComplete="new-password" />
                  <button type="button" onClick={() => setShowPw2(!showPw2)} style={{
                    position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer',
                    fontSize: 12, fontWeight: 600, color: COLORS.grayL, fontFamily: 'inherit',
                  }}>{showPw2 ? 'Ocultar' : 'Ver'}</button>
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: COLORS.navy, marginBottom: 8 }}>
                  ¿Cómo usas KIN?
                </label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {[
                    { id: 'importador', label: '🛬 Importador' },
                    { id: 'exportador', label: '📦 Exportador' },
                    { id: 'consultor',  label: '💼 Consultor' },
                    { id: 'agente',     label: '⚖️ Ag. aduana' },
                  ].map(r => (
                    <button key={r.id} type="button" onClick={() => setRol(r.id)} style={{
                      padding: '10px 8px', border: `1.5px solid ${rol === r.id ? COLORS.teal : COLORS.border}`,
                      borderRadius: 9, background: rol === r.id ? 'rgba(14,165,164,.07)' : '#fff',
                      cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 600,
                      color: rol === r.id ? COLORS.teal : COLORS.gray, transition: '.15s',
                    }}>{r.label}</button>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 20 }}>
                <input type="checkbox" id="terms" checked={terms} onChange={e => setTerms(e.target.checked)}
                  style={{ width: 15, height: 15, marginTop: 2, accentColor: COLORS.teal, flexShrink: 0, cursor: 'pointer' }} />
                <label htmlFor="terms" style={{ fontSize: 12, color: COLORS.gray, lineHeight: 1.55, cursor: 'pointer' }}>
                  Acepto los <span style={{ color: COLORS.teal, fontWeight: 600 }}>Términos de uso</span> y la{' '}
                  <span style={{ color: COLORS.teal, fontWeight: 600 }}>Política de privacidad</span> de KIN.
                </label>
              </div>
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: 14, background: loading ? COLORS.grayL : COLORS.navy,
                color: '#fff', border: 'none', borderRadius: 10,
                fontFamily: 'inherit', fontSize: 15, fontWeight: 800,
                cursor: loading ? 'not-allowed' : 'pointer', marginBottom: 16,
              }}>{loading ? 'Creando cuenta...' : 'Crear cuenta gratis →'}</button>
              <p style={{ textAlign: 'center', fontSize: 13, color: COLORS.gray }}>
                ¿Ya tienes cuenta?{' '}
                <button type="button" onClick={() => { setTab('login'); setError(''); setSuccess(''); }}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: COLORS.teal, fontWeight: 700, fontFamily: 'inherit', fontSize: 13 }}>
                  Iniciar sesión
                </button>
              </p>
            </form>
          )}
          </>
          )}
        </div>
      </div>
    </div>
  );
}
